import { createContext, useContext } from 'react';
import type { MailResource } from '@mrrmlab/api-client';

const MailApiContext = createContext<MailResource | null>(null);

export const MailApiProvider = MailApiContext.Provider;

export function useMailApi(): MailResource {
  const ctx = useContext(MailApiContext);
  if (!ctx) throw new Error('useMailApi called outside <MailApiProvider>');
  return ctx;
}
